import React, { ReactNode, FC, useContext, HTMLAttributes } from 'react';
import { TypeStatics } from 'ia-react-core/~/interfaces/TypeStatic';

import TableContext from '../_TableContext';
import { StyledCell } from './TableCell.styles';

export interface TableCellProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  /** Alignment of the column. */
  textAlign?: string;
  /** Defines the value when the cell is empty. */
  emptyValue?: string;
  /** Flex value of the column. */
  flex?: number;
  /** Width of the column. */
  width?: number | string;
  /** Padding of the cell. */
  padding?: number | string;
}

const TableCellDefaultProps = {
  flex: 1,
};

/**
 * @mode developer
 */
const TableCell: FC<TableCellProps> & TypeStatics = (props) => {
  const { emptyValue, debug, rowPadding, displayMode, noCellWrap } = useContext(TableContext);
  return (
    <StyledCell
      role="cell"
      emptyValue={emptyValue}
      debug={debug}
      padding={rowPadding}
      displayMode={displayMode}
      noCellWrap={noCellWrap}
      {...props}
    />
  );
};

TableCell.defaultProps = TableCellDefaultProps;
TableCell.type = Symbol('Table.Cell');

export default TableCell;
